module.exports = __webpack_public_path__ + "static/media/2.82beaba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/works/dailynook/images/2.png
// module id = 159
// module chunks = 0